

 <div class="text-center mb-6 mx-auto font-normal text-slate-500 dark:text-slate-400 text-sm">
  Première connexion ?

  <ng-container *ngIf="!queryParams.returnUrl?.indexOf('jeunes') && queryParams.returnUrl">
  <br/><a [routerLink]="['/annonces/inscription-demande-logement']"  [queryParams]="queryParams" class="color-orange dark:text-white font-medium hover:underline">
    Je commence ma demande <i class="fa fa-caret-right"></i>
  </a>
  <br/><a [routerLink]="['/jeunes/inscription']" [queryParams]="{mode: 'informe'}" class="color-blue dark:text-white font-medium hover:underline">
    Je souhaite être informé.e <i class="fa fa-caret-right"></i>
  </a>
  </ng-container>
  <ng-container *ngIf="queryParams.returnUrl?.indexOf('jeunes') || !queryParams.returnUrl">
    <br/><a [routerLink]="['/annonces/inscription-demande-logement']"  [queryParams]="queryParams" class="color-orange dark:text-white font-medium hover:underline">
    Je commence ma demande <i class="fa fa-caret-right"></i>
  </a>
  <br/><a [routerLink]="['/jeunes/inscription']" [queryParams]="{mode: 'informe'}" class="color-blue dark:text-white font-medium hover:underline">
    Je souhaite être informé.e <i class="fa fa-caret-right"></i>
  </a>
</ng-container>

</div>

 <div class="text-center  mb-2">
   <h4 class="font-medium">Connexion</h4>
   <div class="text-slate-500 dark:text-slate-400 text-base">
     Je poursuis ma démarche en cours
   </div>
 </div>

 <!-- Impersonation (Dev/Test/Val uniquement) -->
 <div *ngIf="showImpersonation" class="mb-4 p-3 bg-yellow-50 dark:bg-yellow-900 border border-yellow-300 dark:border-yellow-700 rounded">
   <div class="text-xs font-bold text-yellow-800 dark:text-yellow-200 mb-2">
     <i class="fas fa-user-secret"></i> MODE DEV/TEST/VAL - CONNEXION RAPIDE
     <span class="ml-2 text-[10px] opacity-75">(1-2 utilisateurs par rôle/type)</span>
   </div>
   <label class="block text-sm font-medium text-yellow-700 dark:text-yellow-300 mb-1">
     Sélectionner un utilisateur test :
   </label>
   <select
     (change)="onImpersonationUserChange($event)"
     class="form-control w-full text-sm"
     [disabled]="loading">
     <option value="">-- Connexion manuelle --</option>
     <optgroup *ngFor="let role of impersonationUsers | keyvalue" [label]="role.key + ' (' + role.value.length + ')'">
       <option *ngFor="let user of role.value" [value]="user.id">
         {{ user.prenom || '' }} {{ user.nom || '' }} ({{ user.email }})
         <ng-container *ngIf="user.isJeune || user.isProprio || user.isVisiteur">
           - [{{ user.isJeune ? 'Jeune' : '' }}{{ user.isProprio ? (user.isJeune ? '/Proprio' : 'Proprio') : '' }}{{ user.isVisiteur ? 'Visiteur' : '' }}]
         </ng-container>
       </option>
     </optgroup>
   </select>
   <div *ngIf="selectedImpersonationUser" class="mt-3 p-2 bg-white dark:bg-gray-800 rounded border border-yellow-200 dark:border-yellow-600">
     <div class="text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1">
       <i class="fas fa-user-check"></i> Utilisateur sélectionné :
     </div>
     <div class="text-sm font-bold text-gray-900 dark:text-white">
       {{ selectedImpersonationUser.prenom }} {{ selectedImpersonationUser.nom }}
     </div>
     <div class="text-xs text-gray-600 dark:text-gray-400 mb-2">
       {{ selectedImpersonationUser.email }}
     </div>
     <div class="flex flex-wrap gap-1">
       <span *ngIf="selectedImpersonationUser.isJeune"
             class="inline-block px-2 py-0.5 text-[10px] font-semibold rounded bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200">
         <i class="fas fa-user-graduate"></i> Jeune
       </span>
       <span *ngIf="selectedImpersonationUser.isProprio"
             class="inline-block px-2 py-0.5 text-[10px] font-semibold rounded bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200">
         <i class="fas fa-home"></i> Propriétaire
       </span>
       <span *ngIf="selectedImpersonationUser.isVisiteur"
             class="inline-block px-2 py-0.5 text-[10px] font-semibold rounded bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-200">
         <i class="fas fa-eye"></i> Visiteur
       </span>
       <span *ngFor="let role of selectedImpersonationUser.roles"
             class="inline-block px-2 py-0.5 text-[10px] font-semibold rounded bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200">
         <i class="fas fa-shield-alt"></i> {{ role }}
       </span>
     </div>
   </div>
 </div>

 <form class="space-y-4" [formGroup]="loginForm" (ngSubmit)="onSubmit($event)" autocomplete="off">
   <!-- form-signin login" -->

   <div class="fromGroup">
     <label class="block capitalize form-label">Email</label>
     <div class="relative ">
       <input type="email" name="email" class="form-control py-2" formControlName="username" placeholder="Email"
         required autofocus [ngClass]="{ 'is-invalid': submitted && f.username.errors }">
       <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
         <div *ngIf="f.username.errors.required">Nom d'utilisateur requis.</div>
       </div>
     </div>
   </div>
   <div class="fromGroup       ">
     <label class="block capitalize form-label  ">Mot de passe</label>
     <div class="relative ">
       <input type="password" name="password" class="  form-control py-2   " formControlName="password"
         placeholder="Mot de passe" [ngClass]="{ 'is-invalid': submitted && f.password.errors }">

       <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
         <div *ngIf="f.password.errors.required">Le mot de passe est requis</div>
       </div>
     </div>
   </div>
   <button class="btn btn-dark block w-full text-center" type="submit" [disabled]="loading"><i
       class="fas fa-spinner fa-spin" *ngIf="loading"></i>&nbsp;<i
       class="fas fa-sign-in-alt"></i>&nbsp;Connexion</button>


       <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
       <div class="flex justify-between">
        <label class="flex items-center cursor-pointer">
          <!--  <input type="checkbox" class="hiddens">
         <span class="text-slate-500 dark:text-slate-400 text-sm leading-6 capitalize">Keep me signed in</span>-->
        </label>
        <div class="">
         <a class="text-sm text-slate-800 dark:text-slate-400 leading-6 font-medium" href="#"
           (click)="goToChangePassword()">Mot de passe oublié?
         </a><br/>
         <a class="text-sm text-slate-800 dark:text-slate-400 leading-6 font-medium"
           routerLink="/auth/authverify">Activer mon profil
         </a>
        </div>
      </div>

   <!-- <div class="col-12 text-center pt-4"><button class="btn btn-info" type="button" (click)="goBack()"><i class="fa fa-chevron-left"></i>
      Retour</button></div> -->
 </form>

